import { Route } from '@angular/router';
import { PageView } from '@interacta-shared/data-access-common';
import { dynamicImport } from '@interacta-shared/util-common';

/**
 * Mounted by each app under the `licenceRequired` segment, so the page itself is
 * the path-less child: the guard redirects to that single segment.
 */
export const featureLicenseRoutes = (fullPage = false): Route[] => [
    {
        path: '',
        loadComponent: () =>
            dynamicImport(
                () =>
                    import('./pages/license-upgrade-page/license-upgrade-page.component'),
            ).then((m) => m.LicenseUpgradePageComponent),
        data: { id: 'Licence Required' satisfies PageView, fullPage },
    },
];
